import { CaptionContainer, CaptionRuler } from "./style";

export const Caption = ({ text, inblock, smallruler, fontSize }) => {
  return (
    <CaptionContainer
      smallruler={smallruler}
      inblock={inblock}
      fontSize={fontSize || (inblock ? 28 : 35)}
    >
      <CaptionRuler smallruler={smallruler} />
      <nobr>{text}</nobr>
      <CaptionRuler smallruler={smallruler} />
    </CaptionContainer>
  );
};
